import React from "react";
import { OSH_IMAGES } from "../../lib/worldOsharImages";

const OsharIntro = () => {
  const pano = OSH_IMAGES.introPanorama;

  return (
    <section className="oshar-intro" id="oshar-what" aria-labelledby="oshar-what-heading">
      <div className="oshar-intro__frame">
        <div className="oshar-inner oshar-intro__grid">
          <div className="oshar-intro__copy">
            <p className="oshar-section-eyebrow">Lore &amp; Systems</p>
            <h2 id="oshar-what-heading" className="oshar-section-title">
              WHAT IS OSHAR?
            </h2>
            <p className="oshar-prose">
              Oshar is a full VR city woven into Treydora—not a lobby, but a
              persistent skyline of districts, contracts, and crowds. It extends
              the battlefield beyond the RPG campaign: you explore boulevards
              and arcades, socialize in guild halls, trade gear and cosmetics, and
              stake claims that register on-chain.
            </p>
            <p className="oshar-prose">
              Own storefronts and residences, farm reputation in seasonal events,
              and unlock benefits that feed back into the Treydorex economy and
              your progression in the wider universe.
            </p>
          </div>
          <div className="oshar-intro__visual">
            <div className="oshar-intro__img-wrap">
              <img src={pano} alt="Panoramic view of Oshar at night" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OsharIntro;
